import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Cancelling = () => /*#__PURE__*/_jsxs(TFlex, {
  align: "center",
  marginBlock: "500",
  children: [/*#__PURE__*/_jsx(LoadingSpinner, {
    size: "extra-small",
    use: "danger"
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    message: "knowledgeContentUI.importArticles.panel.cancellingImport.message"
  })]
});
export default Cancelling;